import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { apiSlice, SearchResults } from '../api-slice'
import { SearchTypes } from '../../common/constants'
import Search from '../../components/Search';

const pageConfig = (window as any).pageConfig;

interface PageSettings {
    detailPageLinkLabel: string;
    presentationNoun: string;​
    searchTitle: string;
    title: string;
    currentPage: number;
    perPage: number;
    searchResultsCount: number;
    pageLayout: SearchTypes;
    isSearching: boolean;
    linkLabel: string;
    isInMaintenanceMode: boolean;
    maintenanceModeMessaging: string;
    searchResults: SearchResults;
}

const initialState: PageSettings = {
    currentPage: 1,
    perPage: parseInt(pageConfig.pageSize),
    title: pageConfig.title,
    detailPageLinkLabel: pageConfig.detailPageLinkLabel,
    presentationNoun: pageConfig.presentationNoun,
    searchTitle: pageConfig.searchTitle,
    searchResultsCount: 0,
    pageLayout: SearchTypes.ALL,
    isSearching: false,
    linkLabel: pageConfig.detailPageLinkLabel,
    isInMaintenanceMode: false,
    maintenanceModeMessaging: pageConfig.maintenanceModeMessaging,
    searchResults: {
        errorMessage: "",
        innerException: "",
        maintenanceMode: false,
        results: [],
        totalResultCount: 0,
    },
};


const pageSettingsSlice = createSlice({
    name: 'pageSettings',
    initialState,
    reducers: {
        setCurrentPage(state, action: PayloadAction<number>) {
            state.currentPage = action.payload;
        },
        setSearchResults(state, action: PayloadAction<SearchResults>) {
            state.searchResults = action.payload;
        },
        initializeSettings(state) {
            state.perPage = pageConfig.pageSize;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(apiSlice.endpoints.fetchResults.matchPending, (state) => {
            state.isSearching = true;
        })
        builder.addMatcher(apiSlice.endpoints.fetchResults.matchFulfilled, (state, action) => {
            state.searchResultsCount = action.payload.totalResultCount;
            state.isInMaintenanceMode = action.payload.maintenanceMode;
            state.isSearching = false;
        })
       
    }
});

export const { setCurrentPage, setSearchResults, initializeSettings } = pageSettingsSlice.actions;
export default pageSettingsSlice.reducer;
